// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ck-0";
export var fileCarousel = "_ck-2";
export var removeFileButton = "_ck-1";